import type { OfficeSelection } from "@/types/api";

/** Do not revive old Home settings while the taskpane is validating the current selection. */
export function parseOfficeSelection(serialized: unknown): OfficeSelection | null {
  if (typeof serialized !== "string" || !serialized) return null;
  try {
    const value = JSON.parse(serialized);
    if (!value || !identifier(value.organizationId) || !value.context) return null;
    const context = value.context;
    if (context.requestType === "due-diligence" && identifier(context.productId) && identifier(context.requestId)) {
      return {
        organizationId: value.organizationId,
        context: { requestType: "due-diligence", productId: context.productId, requestId: context.requestId },
      };
    }
    if (context.requestType !== "performance" || !identifier(context.reportId)) return null;
    if (context.scope === "firm") {
      return {
        organizationId: value.organizationId,
        context: { requestType: "performance", scope: "firm", reportId: context.reportId },
      };
    }
    if (context.scope === "product" && identifier(context.productId) && identifier(context.fundId)) {
      return {
        organizationId: value.organizationId,
        context: {
          requestType: "performance",
          scope: "product",
          productId: context.productId,
          fundId: context.fundId,
          reportId: context.reportId,
        },
      };
    }
    return null;
  } catch {
    return null;
  }
}

function identifier(value: unknown): value is string {
  return typeof value === "string" && value.trim().length > 0;
}
